export function dispatch<T>(el: EventTarget, name: string, detail?: CustomEventInit<T>["detail"]) {
  const event = new CustomEvent(name, { bubbles: true, cancelable: true, composed: true, detail });
  el.dispatchEvent(event);
  return event;
}

export function createElement<T extends ChildNode = HTMLElement>(html: string) {
  const template = document.createElement("template");
  template.innerHTML = html.trim();
  return template.content.firstChild as T | null;
}
